import React from 'react'
import { Link } from 'react-router-dom';

export default function LandingPageItems({icon, title,link , description }) {
  return (
    <Link to={`${link}`}>
    <div className="slide-items">
        <div className="title">
        {icon}
        <strong>{title}</strong>
        </div>

        <div className='title slide-up'>
          {description}
        </div>

    </div>
    </Link>
  )
}
